export default __webpack_public_path__ + "static/media/license.09a636cc.svg";